import $ from 'jquery';
import selectize from 'selectize';
import { toggleFocus, toggleValidation } from './field';

export const create = ($el, additionalOptions) => {
    let options = {
        valueField: 'ID',
        labelField: 'Name',
        searchField: 'Name',
        copyClassesToDropdown: false,
        onChange: function(dropdown) {
            var $input = $(dropdown)
                .prev()
                .find('input, select');
            toggleValidation($input);
            toggleFocus($input, false);
        },
        ...additionalOptions,
    };

    $el.selectize(options);
};

export const binds = () => {
    // create();
    $('[data-plugin="selectize"]').each(function() {
        create($(this));
    });
};
